<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a class="navbar-brand" :href="i2oc"></a>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-navbar-nav class="d-md-down-none">
<!--       <b-nav-item class="px-3">Dashboard</b-nav-item>
      <b-nav-item class="px-3">Users</b-nav-item>
      <b-nav-item class="px-3">Settings</b-nav-item> -->
      <b-nav-item href="/system/#/help" class="px-3">Help</b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <b-button disabled squared variant="warning" v-if="isDownloading">Downloading
          <i class="fa fa-circle-o-notch fa-spin"></i>
      </b-button>
      <div  v-if="enableDownloadButton">
      <b-button squared variant="success" v-if="!isDownloading" @click="downloadData" >Download</b-button></div>
<!--       <b-nav-item class="d-md-down-none">
        <i class="icon-bell"></i>
        <b-badge pill variant="danger">5</b-badge>
      </b-nav-item>
      <b-nav-item class="d-md-down-none">
        <i class="icon-list"></i>
      </b-nav-item>
      <b-nav-item class="d-md-down-none">
        <i class="icon-location-pin"></i>
      </b-nav-item> -->
      <HeaderDropdown/>
    </b-navbar-nav>
<!--     <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
      <span class="navbar-toggler-icon"></span>
    </button> -->
  </header>
</template>
<script>
  import HeaderDropdown from './HeaderDropdown.vue'
  const config = require('../../config.json')
  export default {
    name: 'c-header',
    components: {
      HeaderDropdown
    },
    data(){
      return{
        isDownloading:false,
        enableDownloadButton: config.downloadButton.enable,
        i2oc:this.$http.defaults.baseURL
      }
    },
    methods: {
      downloadData() {
        let _this = this;
        this.isDownloading = true;
        this.$http.get('/api/users/download_data').then(function (response) {
          if(response.status == 200) {
            _this.$http.get('/api/containers/default_database_schema/download/'+response.data, {responseType: 'blob'}).then(function (responseDownload) {
                let link = document.createElement('a');
                link.href = URL.createObjectURL(responseDownload.data);
                link.download = response.data
                document.body.appendChild(link);
                link.click()
                document.body.removeChild(link);
            });
            _this.isDownloading = false;
          } else {
            alert('Unable to download user data. Please try again or contact administrator is problem continious')
            _this.isDownloading = false;
          }
        }).catch(function(err) {
            alert('Something went wrong')
        });

      },
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      asideToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('aside-menu-hidden')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/Header.vue